var _g, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3262 645",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.831839,-0.222891,0.222891,0.831839,-1486.1,-2178.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1276.68,3011.38C1090.82,3011.38 939.931,3162.27 939.931,3348.12C939.931,3533.98 1090.82,3684.87 1276.68,3684.87C1462.53,3684.87 1613.42,3533.98 1613.42,3348.12C1613.42,3162.27 1462.53,3011.38 1276.68,3011.38L1276.68,3011.38ZM1276.68,3057.82C1436.9,3057.82 1566.98,3187.9 1566.98,3348.12C1566.98,3508.34 1436.9,3638.42 1276.68,3638.42C1116.46,3638.42 986.379,3508.34 986.379,3348.12C986.379,3187.9 1116.46,3057.82 1276.68,3057.82Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.449193,-0.120361,0.12575,0.469304,-802.113,-1058.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1566.98,3348.12C1566.98,3187.8 1437,3057.82 1276.68,3057.82C1116.35,3057.82 986.379,3187.8 986.379,3348.12",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "84.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.449193,0.120361,-0.12575,-0.469304,1446.43,1702.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1566.98,3348.12C1566.98,3187.8 1437,3057.82 1276.68,3057.82C1116.35,3057.82 986.379,3187.8 986.379,3348.12",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "84.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-869.667,-1930.7)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "1603.52px",
    y: "2411.09px",
    style: {
      fontFamily: "'Inter-Regular', 'Inter'",
      fontSize: 500
    }
  }, "r", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "1781.08px ",
    y: "2411.09px "
  }, "o")), "undtable"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logo-with-text.6e6eb0db62d17a2e6ed551d841091528.svg";
export { ForwardRef as ReactComponent };